import { useApi } from '../context/DemoContext';
import { dtt } from '../lib/api';
import { ErrorState, Loading, PageHeader, Panel } from '../components/common';

const ST = {
  working: ['Working demonstration', 'border-emerald-500/40 text-emerald-300 bg-emerald-500/10'],
  simulated: ['Simulated integration', 'border-cyan-500/40 text-cyan-300 bg-cyan-500/10'],
  future: ['Future development', 'border-slate-500/40 text-slate-300 bg-slate-500/10'],
  requires_approval: ['Requires Barloworld approval / data access', 'border-amber-500/40 text-amber-300 bg-amber-500/10'],
};
const Badge = ({ s }) => <span className={`rounded border px-2 py-0.5 text-[11px] ${ST[s][1]}`}>{ST[s][0]}</span>;

export default function Sources() {
  const { data: d, error, status } = useApi('/sources');
  if (error) return <ErrorState error={error} status={status} />;
  if (!d) return <Loading />;
  return (
    <div className="space-y-5" data-testid="sources-page">
      <PageHeader code="S10" title="Sources, Evidence & Integration Status" crumbs={[{ label: 'Platform' }, { label: 'Sources' }]}
        subtitle="Where every record comes from. No live integration with Barloworld, Equify, banks, credit bureaus, CAT systems or other third parties is claimed." />
      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">{d.sources.map((s) => (
        <div key={s.id} className="panel p-4 fade-up" data-testid={`source-${s.id}`}>
          <div className="flex items-start justify-between gap-2"><div className="font-display font-semibold text-white">{s.name}</div><Badge s={s.status} /></div>
          <div className="mt-1 font-mono text-[10px] uppercase tracking-wider text-[#00A9CE]">{s.kind}</div>
          <p className="mt-2 text-sm text-slate-400">{s.description}</p>
          <div className="mt-2 font-mono text-[10px] text-slate-500">Freshness: {s.status === 'working' || s.status === 'simulated' ? `refreshed ${dtt(s.last_refreshed)}` : 'not connected'}</div>
        </div>))}</div>
      <div className="grid gap-4 xl:grid-cols-2">
        <Panel title="Capability status" testid="capabilities">
          {d.capabilities.map((c) => <div key={c.name} className="flex items-center justify-between gap-3 border-b border-[#1E2A45] py-2 text-sm last:border-0"><span>{c.name}</span><Badge s={c.status} /></div>)}
        </Panel>
        <Panel title="Record provenance" eyebrow="Counts by source label" bodyClass="pb-2" testid="provenance">
          <table className="tbl"><thead><tr><th>Collection</th><th>Source</th><th>Records</th></tr></thead>
            <tbody>{Object.entries(d.record_counts).flatMap(([c, m]) => Object.entries(m).map(([s, n]) => <tr key={c + s}><td className="font-mono text-xs">{c}</td><td className="text-xs">{s}</td><td className="font-mono">{n}</td></tr>))}</tbody></table>
        </Panel>
      </div>
      <Panel title="Branding & imagery provenance" testid="asset-provenance">
        <ul className="space-y-1.5 text-sm text-slate-300">
          <li>Barloworld Equipment / CAT logo — sourced from barloworld-equipment.com (official website). <span className="text-[#FFCD00]">Usage approval pending.</span></li>
          <li>Machinery photography — Unsplash licence (free commercial use), stored locally in the app. Images illustrate equipment classes only; no photographed machine is an actual financed asset.</li>
          <li>Map tiles — Esri World Dark Gray Canvas basemap (CARTO dark tiles required an API key for this domain). Marker coordinates are synthetic.</li>
        </ul>
      </Panel>
    </div>
  );
}
